module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "edit-developer-basic-info"
    }
  }, [_c('div', {
    staticClass: "basic-info edit-container"
  }, [(_vm.formData.delete !== 'DELETE') ? [_c('h1', [_vm._v("Account Settings")]), _vm._v(" "), _c('div', {
    staticClass: "set"
  }, [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.alias),
      expression: "formData.alias"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Username",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.formData.alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.alias = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('label', [_vm._v("Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email),
      expression: "formData.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email Address",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.formData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.showEmailError) ? _c('div', {
    staticClass: "validation-messages friendly"
  }, [_vm._v("\n                    Not a valid Email Address\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "set"
  }, [_c('label', [_vm._v("Emails")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.receiveEmailNotifications),
      expression: "formData.receiveEmailNotifications"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.receiveEmailNotifications) ? _vm._i(_vm.formData.receiveEmailNotifications, null) > -1 : (_vm.formData.receiveEmailNotifications)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.receiveEmailNotifications,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.receiveEmailNotifications = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.receiveEmailNotifications = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.receiveEmailNotifications = $$c
        }
      }
    }
  }), _vm._v("Receive Email Notifications")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.receivePromoEmails),
      expression: "formData.receivePromoEmails"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.receivePromoEmails) ? _vm._i(_vm.formData.receivePromoEmails, null) > -1 : (_vm.formData.receivePromoEmails)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.receivePromoEmails,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.receivePromoEmails = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.receivePromoEmails = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.receivePromoEmails = $$c
        }
      }
    }
  }), _vm._v("Receive Official Emails")])]), _vm._v(" "), _c('div', {
    staticClass: "set"
  }, [_c('label', [_vm._v("Change Password\n                    "), (!_vm.passwordsShown) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.passwordsShown = true
      }
    }
  }, [_vm._v("Show")]) : _vm._e(), _vm._v(" "), (_vm.passwordsShown) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.passwordsShown = false
      }
    }
  }, [_vm._v("Hide")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [(!_vm.passwordsShown) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "New Password",
      "disabled": _vm.isSaving,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.passwordsShown) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Password",
      "disabled": _vm.isSaving,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [(!_vm.passwordsShown) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.passwordAgain),
      expression: "formData.passwordAgain"
    }],
    attrs: {
      "type": "password",
      "placeholder": "New Password Again",
      "disabled": _vm.isSaving,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.formData.passwordAgain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.passwordAgain = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.passwordsShown) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.passwordAgain),
      expression: "formData.passwordAgain"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Password Again",
      "disabled": _vm.isSaving,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.formData.passwordAgain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.passwordAgain = $event.target.value
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.formData.password.length > 0 && _vm.formData.password !== _vm.formData.passwordAgain) ? _c('div', {
    staticClass: "validation-messages friendly"
  }, [_vm._v("\n                Passwords do not match\n            ")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "set"
  }, [_c('label', [_vm._v("Delete Account")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_vm._v("Type DELETE and press Save")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.delete),
      expression: "formData.delete"
    }],
    attrs: {
      "type": "text",
      "placeholder": "delete?",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.formData.delete)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.delete = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.formData.delete === 'DELETE') ? _c('div', {
    staticClass: "validation-messages friendly",
    attrs: {
      "disabled": _vm.isSaving
    }
  }, [_vm._v("\n                If you press SAVE, your account will be deleted. This cannot be undone.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.responseErrors.length > 0) ? _c('div', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.responseErrors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button minor",
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitChanges($event)
      }
    }
  }, [_vm._v("Save")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10fd2422!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Developer/Widgets/EditAccountInfo.vue
// module id = 824
// module chunks = 2